import axios from "axios";
import './ExistingAccount.css';
import { conn } from "../../Utilt/conn";
import React,{ useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Sidenav } from "../SideNav/Sidenav.js";
import { CustomNavbar } from "../CustomNavbar/customnabar.jsx";
import { BsSearch } from 'react-icons/bs'
import {FiEdit2} from 'react-icons/fi'
import Loader from "../Loader/Loader";
import { getConfig } from "../../Utilt/Config";

import ChangePin from "./changePin";
import ConfirmAdminPin from "./changePin/confirmPin";
import ProgressLoaderPin from "./changePin/loader";
import SuccessPin from "./changePin/success";
import BasicMenu from "./menu/menu";

import ChangePassword from "./changePassword";
import ConfirmAdminPassword from "./changePassword/confirmPassword";
import ProgressLoaderPassword from "./changePassword/loader";
import SuccessPassword from "./changePassword/success";


export function ExistingAccounts() {

    const auth = JSON.parse(window.localStorage.getItem("auth"));
    const navigate = useNavigate();

    const [openD, setOpen] = useState(false);
    

    useEffect(() => {
        UsersAccountData();
    }, []);

    const handleCloseD = () => {
        setOpen(false);
    };


    const [isloading, loading] = useState(false);
    const [data, setData] = useState([]);
    const [nuban, setNuban] = useState("");


    const input = document.querySelector(".nuban");

    const setInput = (e)=>{
        setNuban(e.target.value);
        input.addEventListener("keypress", async (event) => {
            if (event.key === 'Enter') {
                loading(true);
                console.log(e.target.value);
                setData([]);
                UsersAccountData(e.target.value);
                return;
            }
        }, { once: true });
        // console.log(nuban);
    }



    const UsersAccountData = async (_input) => {
        loading(true);
        await axios.post(conn + "/admin/get-account-by-nuban"
            , {
                nuban: _input,
            },
            getConfig()
        ).then((value) => {
            setData([value.data.data]);
            loading(false);
        }).catch((error) => {
            console.log(error);
            loading(false);
            if (error.response.status === 401) navigate('/login')
        });
    }


    const UserTierUpgrade = async (account_id, top_tier, admin_id) => {
     setOpen(true);
        await axios.post(conn + "/admin/account/upgrade", {
            "account_id": account_id,
            "to_tier": top_tier,
            "admin_id": admin_id
        }, getConfig()).then((value) => {
            console.log(value.data)
            setOpen(false);
            setData([...data].map((val) =>
                val.id === account_id ? { ...val, account_tier: top_tier} : val

            ))
        }).catch((error) => {
            setOpen(false);
            if (error.response.status === 401) navigate('/login')
        });
    }

    // CHANGE PIN AND PASSWORD, MENU AND MODAL
    const [openMenu, setOpenMenu] = React.useState(null);
    const handleOpenMenu = (event) => {
        setOpenMenu(event.currentTarget);
      };
      

    // Change Pin management
    const [openChangePin, setOpenChangePin] = useState(false)
    const [openConfirmPin, setOpenConfirmPin] = useState(false)
    const [openLoaderPin, setOpenLoader] = useState(false)
    const [openSuccessPin, setOpenSuccessPin] = useState(false)
    const [adminNewPin, setAdminNewPin] = useState({})


    const handleOpenChangePin = () => {
        setOpenChangePin(true)
    }
  
    const handleCloseChangePin = () => {
        setOpenChangePin(false)
    }
    const handleSubmitChangePin = (pinData) => {
        setAdminNewPin(pinData)
        setOpenChangePin(false)
        setOpenConfirmPin(true)
    }

    const handleCloseConfirmPin = () => {
        setOpenConfirmPin(false)
    }
    const handleSubmitConfirm = () =>{
        setOpenConfirmPin(false)
        setOpenLoader(true)
    }
  
    const handleCloseLoaderPin = () => {
        setOpenLoader(false)
        setOpenSuccessPin(true)
    }

    const handleCloseSuccessPin = () => {
        setOpenSuccessPin(false)
    }


    // Change Password management
    const [openChangePassword, setOpenChangePassword] = useState(false)
    const [openConfirmPassword, setOpenConfirmPassword] = useState(false)
    const [openLoaderPassword, setOpenLoaderPassword] = useState(false)
    const [openSuccessPassword, setOpenSuccessPassword] = useState(false)
    const [adminNewPassword, setAdminNewPassword] = useState({})


    const handleOpenChangePassword = () => {
        setOpenChangePassword(true)
    }
  
    const handleCloseChangePassword = () => {
        setOpenChangePassword(false)
    }
    const handleSubmitChangePassword = (passwordData) => {
        setAdminNewPassword(passwordData)
        setOpenChangePassword(false)
        setOpenConfirmPassword(true)
    }

    const handleCloseConfirmPassword = () => {
        setOpenConfirmPassword(false)
    }
    const handleSubmitConfirmPassword = () =>{
        setOpenConfirmPassword(false)
        setOpenLoaderPassword(true)
    }
  
    const handleCloseLoaderPassword = () => {
        setOpenLoaderPassword(false)
        setOpenSuccessPassword(true)
    }

    const handleCloseSuccessPassword = () => {
        setOpenSuccessPassword(false)
    }



    return (

        <div className="existing-account">
            <Sidenav />

            <BasicMenu openMenu={openMenu} setOpenMenu={setOpenMenu}
             handleOpenChangePin={handleOpenChangePin} handleOpenChangePassword={handleOpenChangePassword}/>

            {/* CHANGE PIN MANAGEMENT */}
            {openChangePin && <ChangePin openChangePin={openChangePin} handleCloseChangePin={handleCloseChangePin} submitChangePin={(pinData)=>handleSubmitChangePin(pinData)} data={data}/> }
            <ConfirmAdminPin openConfirm={openConfirmPin} handleCloseConfirm={handleCloseConfirmPin} handleSubmitConfirm={handleSubmitConfirm}/>
            {openLoaderPin && <ProgressLoaderPin openLoader={openLoaderPin} handleCloseLoader={handleCloseLoaderPin} data={adminNewPin} _user={data}/> }
            {openSuccessPin && <SuccessPin openSuccesPin={openSuccessPin} handleCloseSuccessPin={handleCloseSuccessPin} _user={data} pin={adminNewPin}/> }
            

            {/* CHANGE PASSWORD MANAGEMENT */}
            {openChangePassword && <ChangePassword openChangePassword={openChangePassword} handleCloseChangePassword={handleCloseChangePassword} submitChangePassword={(passwordData)=>handleSubmitChangePassword(passwordData)} data={data}/> }
            <ConfirmAdminPassword openConfirm={openConfirmPassword} handleCloseConfirm={handleCloseConfirmPassword} handleSubmitConfirm={handleSubmitConfirmPassword}/>
            {openLoaderPassword && <ProgressLoaderPassword openLoader={openLoaderPassword} handleCloseLoader={handleCloseLoaderPassword} data={adminNewPassword} _user={data}/> }
            {openSuccessPassword && <SuccessPassword openSuccesPassword={openSuccessPassword} handleCloseSuccessPassword={handleCloseSuccessPassword} _user={data} password={adminNewPassword}/> }
            
            
            
            
            <div className="body the-body">

                <CustomNavbar label={"Customers Account"} />

                
                <div className="in">

                    <div className="search-area">
                        <Fade duration={1000}>
                        <input type="text" value={nuban} onChange={(e)=>setInput(e)} className="nuban" placeholder="Enter NUBAN to find Acccount" />
                        <span style={{cursor:"pointer"}} onClick={()=>UsersAccountData(nuban)} ><BsSearch /></span>
                        </Fade>
                    </div>


                    <div className="accounts-list">
                        <p>Recent account searches</p>
                        {(!isloading) ?<div className="table">
                            <table cellSpacing="0">
                                <thead>
                                    <td>Name</td>
                                    <td>Nuban</td>
                                    <td>Date Of Creation</td>
                                    <td>Tier</td>
                                    <td>Transactions</td>
                                    <td>Secuirity</td>
                                </thead>
                                { 
                                        data.map((user) =>
                                        <tr>        
                                                <td>
                                                    <Fade duration={1000}>{user.account_name}</Fade>
                                                </td>
                                                <td >
                                                    <Fade duration={1000}>{user.nuban}</Fade>
                                                </td>
                                                <td >
                                                    <Fade duration={1000}>{user.created_at.substring(0, 10)}</Fade>
                                                </td>
                                                <td>
                                                   <Fade duration={1000}> <span className="select-cont"> <select value={user.account_tier} onChange={(e) => UserTierUpgrade(user.id, e.target.value, auth.id)}>
                                                        <option value="1">Tier 1</option>
                                                        <option value="2">Tier 2</option>
                                                        <option value="3">Tier 3</option>
                                                    </select></span>
                                                    </Fade>
                                                </td>
                                                <td>
                                                    <Fade duration={1000}><div style={{cursor:"pointer", color:"green"}} onClick={()=>navigate('/transactions', {state:{id:user.id, nuban:user.nuban}}) } >
                                                    See transactions
                                                        </div></Fade>
                                                </td>
                                                <td>
                                                    <FiEdit2 className="edit-icon" onClick={handleOpenMenu}/>
                                                </td>
                                                
                                            </tr>
                                            
                                        )
                                    }
                            </table>
                        </div>:<><Loader /></>}
                    </div>
                </div>
            </div>

           

            <Dialog
                open={openD}
                onClose={handleCloseD}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            
                <DialogContent>
                    <center>
                        <div style={{ width: "200px",  padding: "30px" }}>

                            <p className="dialog-text">Okay, We're upgrading the Account Tier now</p>
                            <br></br>

                            <div class="sk-bounce">
                                <div class="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                <div class="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                            </div>

                        </div>
                    </center>
                </DialogContent>
                
            </Dialog>

        </div>

    );


}